import Loadable from 'react-loadable';

export const FullPageNotificationsView = Loadable({
  loader: () => import(/* webpackChunkName: "FullPageNotifications" */ './FullPageNotifications'),
  loading: () => null,
});
